import PropTypes from 'prop-types'
import React from 'react'
import { Item } from '../Item'
import { connect } from 'react-redux'
import { getCurrentAd, getSpecsIdForMainProps, getSortedSpecifications } from '../../../selectors'
import { sortSpecifications } from '../../../functions'

export const SpecificationsList = ({ad, arSpecsId, sortedSpecs}) => {
  let specifications = []
  if (ad && ad.category && ad.category.requiredAdOptions === 'Services') {
    if (ad.service && ad.serviceType) {
      specifications.push({id: `service-${ad.service.id}`, property: 'Usluga', value: `${ad.service.name}`})
      specifications.push({
        id: `serviceType-${ad.serviceType.id}`,
        property: 'Tip usluge',
        value: `${ad.serviceType.name}`
      })
    }
  } else {
    if (Array.isArray(ad.adsSpecifications)) {
      const isSpecsShown = ad.category.specsShownWeb
      if (!isSpecsShown) {
        specifications = ad.adsSpecifications
      } else {
        specifications = ad.adsSpecifications.filter(item => !arSpecsId.includes(item.specification.id))
      }

      specifications = specifications.map(item => {
        let weight = 1000
        const arWeightDetails = sortedSpecs.filter(spec => spec.specification && spec.specification.id === item.specification.id)
        if (arWeightDetails.length) {
          weight = arWeightDetails[0].weightDetails
        }

        let value = item.value

        if (item.specification.type === 'multiselect') {
          try {
            value = JSON.parse(item.value)
          } catch (err) {
            value = item.value
          }
        }

        return {
          id: `${item.id}`,
          property: item.specification.title,
          unit: item.specification.measure,
          value: value,
          weightDetails: weight
        }
      })

      sortSpecifications(specifications)
    }
  }
  return specifications.map(item => <Item key={`spec-${item.id}`} {...item} />)
}

const mapStateToProps = state => ({
  ad: getCurrentAd(state),
  sortedSpecs: getSortedSpecifications(state),
  arSpecsId: getSpecsIdForMainProps(state)
})

SpecificationsList.propTypes = {
  ad: PropTypes.shape({
    category: PropTypes.shape({
      requiredAdOptions: PropTypes.oneOf(['BrandModel', 'BrandOnly', 'Services', null])
    }),
    service: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    }),
    serviceType: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    }),
    adsSpecifications: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      value: PropTypes.string.isRequired,
      specification: PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string,
        measure: PropTypes.string
      }).isRequired
    }))
  }).isRequired,
  arSpecsId: PropTypes.arrayOf(PropTypes.number),
  sortedSpecs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    weightDetails: PropTypes.number
  }))
}

SpecificationsList.defaultProps = {
  arSpecsId: [],
  sortedSpecs: []
}

export default connect(mapStateToProps)(SpecificationsList)
